var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.976 1.631a6.03 6.03 0 0 0-2.238 8.181l.106.188H4.5A2.5 2.5 0 0 0 2 12.5v8A2.5 2.5 0 0 0 4.5 23h15a2.5 2.5 0 0 0 2.5-2.5v-8a2.5 2.5 0 0 0-2.5-2.5H7.992l-.383-.679a5.03 5.03 0 0 1 1.867-6.824l.24-.139a4.75 4.75 0 0 1 6.49 1.739l.874 1.515a.5.5 0 1 0 .866-.5l-.875-1.515a5.75 5.75 0 0 0-7.855-2.105zM3 12.501A1.5 1.5 0 0 1 4.5 11h15a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 20.5z",
    clipRule: "evenodd"
  })));
});
const SvgUnlock = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlock);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljk3NTUxIDEuNjMxMTNDNi4xMTMxNiAzLjI4MzcxIDUuMTE1MjUgNi45MzI5MyA2LjczODM3IDkuODEyMUw2Ljg0NDQ3IDEwLjAwMDNINC41QzMuMTE5MjkgMTAuMDAwMyAyIDExLjExOTYgMiAxMi41MDAzVjIwLjUwMDNDMiAyMS44ODEgMy4xMTkyOSAyMy4wMDAzIDQuNSAyMy4wMDAzSDE5LjVDMjAuODgwNyAyMy4wMDAzIDIyIDIxLjg4MSAyMiAyMC41MDAzVjEyLjUwMDNDMjIgMTEuMTE5NiAyMC44ODA3IDEwLjAwMDMgMTkuNSAxMC4wMDAzSDcuOTkyNDNMNy42MDk0OCA5LjMyMTAxQzYuMjU1NjIgNi45MTk0NiA3LjA4Nzk4IDMuODc1NiA5LjQ3NTUxIDIuNDk3MTZMOS43MTY0NiAyLjM1ODA0QzExLjk4ODQgMS4wNDYzNyAxNC44OTM0IDEuODI0NzcgMTYuMjA1MSA0LjA5NjY2TDE3LjA4MDEgNS42MTIyMUMxNy4yMTgyIDUuODUxMzUgMTcuNTIzOSA1LjkzMzI5IDE3Ljc2MzEgNS43OTUyMkMxOC4wMDIyIDUuNjU3MTUgMTguMDg0MiA1LjM1MTM1IDE3Ljk0NjEgNS4xMTIyMUwxNy4wNzExIDMuNTk2NjZDMTUuNDgzMyAwLjg0NjQ4MSAxMS45NjY2IC0wLjA5NTgwMTUgOS4yMTY0NiAxLjQ5MjAyTDguOTc1NTEgMS42MzExM1pNMyAxMi41MDAzQzMgMTEuNjcxOSAzLjY3MTU3IDExLjAwMDMgNC41IDExLjAwMDNIMTkuNUMyMC4zMjg0IDExLjAwMDMgMjEgMTEuNjcxOSAyMSAxMi41MDAzVjIwLjUwMDNDMjEgMjEuMzI4NyAyMC4zMjg0IDIyLjAwMDMgMTkuNSAyMi4wMDAzSDQuNUMzLjY3MTU3IDIyLjAwMDMgMyAyMS4zMjg3IDMgMjAuNTAwM1YxMi41MDAzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";